"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstoqueMinMax = void 0;
var EstoqueMinMax = /** @class */ (function () {
    function EstoqueMinMax() {
        this._id = { material: '', grade: '', dataRem: '' };
        this.DATA_REM = '';
        this.MATERIAL = '';
        this.GRADE = '';
        this.ESTQ_SEG = 0;
        this.CHAVE_COMP = { material: '', grade: '', dataRem: '' };
    }
    return EstoqueMinMax;
}());
exports.EstoqueMinMax = EstoqueMinMax;
//# sourceMappingURL=EstoqueMinMax.js.map